import { SearchLg } from '@untitled-ui/icons-react/build/cjs';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import kate from 'src/assets/img/agent/kate-agent-space.png';
import BadgeCmp from 'src/components/BadgeCmp';
import InputText from 'src/components/InputText/InputText';

import AiCommonModal from './AiCommonModal';
import AiQuestionSelection from './AiCommonModal/AiQuestionSelection';
import RowListsBox from './AiCommonModal/RowListsBox';

interface IProps {
    handleClose: () => void;
}

const NewDomain = ({ handleClose }: IProps) => {
    const { t } = useTranslation();
    const [selectedOptionIds, setSelectedOptionIds] = useState<(string | number)[]>([]);
    const [otherText, setOtherText] = useState('');

    return (
        <AiCommonModal title="New Domain" handleClose={handleClose} primaryBtnText="Submit">
            <div className="space-y-3">
                <p className="">
                    <span className="text-grayLight900 font-semibold">hccompanies.com</span>&nbsp;isn’t linked to any customer yet. I won’t attach it on my own — pick account it belongs to.
                </p>
                <RowListsBox
                    rows={[
                        { label: 'Email', value: 'admin@hccompanies.com' },
                        { label: 'Status', value: 'Unknown Domain' },
                    ]}
                />
                <InputText
                    parentClassName="w-full"
                    inputName="searchConversation"
                    placeholder={t('Common.Search')}
                    className={`pl-8`}
                    inputWrapClass=""
                    icon={<SearchLg className={`absolute -translate-y-2/4 top-2/4 left-2.5 text-grayText h-[16px] w-[16px]`} />}
                    isClearable={true}
                    searchIconClass="!right-[70px]"
                    value={''}
                    inputType="text"
                    onChangeFunc={() => {}}
                />
                <AiQuestionSelection
                    options={[
                        { id: 'save', title: 'Save as contact', subtitle: 'Link this domain to an existing customer account', image: kate },
                        {
                            id: 'broken',
                            title: 'HC Companies',
                            subtitle: 'Image fails — shows initials fallback',
                            image: 'invalid-url.png',
                            rightSideValue: (
                                <BadgeCmp style="pill" type="success">
                                    98%
                                </BadgeCmp>
                            ),
                        },
                        { id: 'later', title: "I'll do this later", subtitle: 'Skip for now and decide later' },
                        {
                            id: 'other',
                            title: 'Other',
                            subtitle: 'None of these — let me specify',
                            content: (
                                <InputText
                                    parentClassName="w-full"
                                    inputName="otherReason"
                                    placeholder="Type your reason"
                                    value={otherText}
                                    inputType="text"
                                    onChangeFunc={(e) => setOtherText(e.target.value)}
                                />
                            ),
                        },
                    ]}
                    selectedIds={selectedOptionIds}
                    onChange={setSelectedOptionIds}
                    checkBoxSelection
                />
            </div>
        </AiCommonModal>
    );
};

export default NewDomain;
